import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import '../css/Header.css';
import '../css/responsive.css';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate();
  const [isNavActive, setIsNavActive] = useState(false);

  const gotoHome = () => {
    navigate('/');
  };

  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    gotoHome();
  };

  const handleToggle = () => {
    setIsNavActive(!isNavActive);
  };

  return (
    <div className={`header-container ${isNavActive ? 'active' : ''}`}>
      <div className="header-logo" onClick={gotoHome}>
        Aqua Treat Systems
      </div>
      <nav className={`header-nav ${isNavActive ? 'active' : ''}`}>
        <NavLink className="header-nav-item" to="/" activeclassname="active">
          Home
        </NavLink>
        <NavLink className="header-nav-item" to="/products" activeclassname="active">
          Products
        </NavLink>
        <NavLink className="header-nav-item" to="/contact" activeclassname="active">
          Contact
        </NavLink>
        {localStorage.getItem('token') === null ? (
          <Link className="header-nav-item btn btn-light" to="/login">
            Admin <br />Login 
          </Link>
        ) : (
          <Link className="header-nav-item btn btn-light" onClick={handleLogout}>
            Logout <br /> {localStorage.getItem('username')}
          </Link>
        )}
        
      </nav>
      <div className={`hamburger-menu ${isNavActive ? 'active' : ''}`}>
          <i className={`fa fa-bars fa-lg `} onClick={handleToggle}></i>
      </div>
    </div>
  );
};

export default Header;
